export default __webpack_public_path__ + "static/media/login.ebb6beaa.svg";